import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { testUrl } from "../BaseData";
import styles from "./HeroAlumni.module.css";

const getDisplayName = (a) =>
    a.full_name || `${a.surname_uz || ""} ${a.name_uz || ""}`.trim() || "Bitiruvchi";

const getInitials = (a) => {
    const name = (a.full_name || `${a.surname_uz || ""} ${a.name_uz || ""}`).trim();
    const letters = name
        .split(/\s+/)
        .map((p) => p[0])
        .filter((ch) => ch && /\p{L}/u.test(ch));
    return letters.slice(0, 2).join("").toUpperCase();
};

// Eski importlarda faculty'ga JSHIR (raqamlar) tushib qolgan — uni chiqarmaymiz.
const getField = (a) => {
    const edu = a.education_field && String(a.education_field).trim();
    if (edu) return edu;
    const fac = a.faculty && String(a.faculty).trim();
    if (fac && !/^\d{9,}$/.test(fac)) return fac;
    return a.workplace ? String(a.workplace).trim() : "";
};

const HeroAlumni = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [alumni, setAlumni] = useState([]);

    const openAlumni = (a) => {
        const lang = (i18n.language || "uz").split("-")[0];
        navigate(`/${lang}/activity/talabalarga/bitiruvchilar?alumni=${a.id}`);
    };

    useEffect(() => {
        axios
            .get(testUrl + "/api/alumni/")
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : res.data.results || [];
                setAlumni(data);
            })
            .catch(() => {});
    }, []);

    // Ko'p bo'lsa yuklamaslik uchun cheklaymiz. Uzluksiz aylanish (marquee) uchun
    // ro'yxatni ikki marta takrorlaymiz — -50% ga surilib, sidirg'a qaytadi.
    const list = useMemo(() => alumni.slice(0, 12), [alumni]);
    if (list.length === 0) return null;
    const loop = [...list, ...list];

    return (
        <div className={styles.wrap}>
            <p className={styles.heading}>{t("Bizning bitiruvchilar")}</p>
            <div className={styles.panel}>
                <div className={styles.track}>
                    {loop.map((a, i) => {
                        const field = getField(a);
                        return (
                            <div
                                className={styles.card}
                                key={`${a.id}-${i}`}
                                role="button"
                                tabIndex={0}
                                title={getDisplayName(a)}
                                onClick={() => openAlumni(a)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        openAlumni(a);
                                    }
                                }}
                            >
                                <div className={styles.photo}>
                                    {a.image ? (
                                        <img src={a.image} alt="" />
                                    ) : (
                                        <span>{getInitials(a)}</span>
                                    )}
                                </div>
                                <div className={styles.info}>
                                    <p className={styles.name}>{getDisplayName(a)}</p>
                                    {field && <p className={styles.field}>{field}</p>}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default HeroAlumni;
